module.exports = __webpack_public_path__ + "static/media/packaging.214cf370.jpg";